import styled from "styled-components/macro";
import {TabsEnum} from "./Passport";
import {AccountInfo} from "./AccountInfo/AccountInfo";
// import {EducationsInfo} from "./Education/EducationsInfo";
// import {Career} from "./Career/Career";
// import {Security} from "./Security/Security";
import {ITab} from "./SideBar";
import React from "react";
// import {FAQ} from "./Pages/FAQ";
import {WindowSizePXEnum} from "../../interface/Basic/window";

interface AccountContentProps {
    current: ITab
}

export const AccountContent = ({current}: AccountContentProps) => {

    const router = () => {
        switch (current.id) {
            case TabsEnum.Account: {
                return <AccountInfo/>
            }
            // case TabsEnum.Education: {
            //     return <EducationsInfo/>
            // }
            // case TabsEnum.Career: {
            //     return <Career/>
            // }
            // case TabsEnum.Security: {
            //     return <Security/>
            // }
            // case TabsEnum.FAQ: {
            //     return <FAQ/>
            // }
            default :
                return <AccountInfo/>
        }
    }

    return <AccountContentContainer>
        {router()}
    </AccountContentContainer>
}

const AccountContentContainer = styled.div`
  display: flex;
  width: 900px;
  flex-direction: column;
  gap: 32px;
  @media (max-width: ${WindowSizePXEnum.md}) {
    display: contents;
    width: unset;
  }
`